export const UPDATE_SEARCHLIST = 'availableJobSearch/updateResults'
export const RESET_FILTERS = 'availableJobSearch/reset'
export const RESET_RESULTS = 'availableJobSearch/resetTableData'
export const UPDATE_CONTROL_NO = 'availableJobAdd/getControlNo'
export const GET_DETAIL = 'availableJob/getDetails'
export const SET_CONFIRM_MODAL = 'availableJobSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'availableJobSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'availableJobSearch/showConfirmModal'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'availableJobSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'availableJobSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'availableJobSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'availableJobSearch/changePageSize'
export const CHG_FILTER_SORT = 'availableJobSearch/changeSortModel'
export const IS_LOADING = 'availableJobSearch/isLoading'
export const CHG_SELECTED_ROWS = 'availableJobSearch/changeSelected'
export const HIDE_LIST_ALERT = 'availableJobSearch/hideAlert'
export const SET_LIST_ALERT = 'availableJobSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'availableJobAdd/changeField'
export const CHG_STATUS = 'availableJobAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'availableJobAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'availableJobAdd/changeIncomeId'
export const CHG_AMOUNT = 'availableJobAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'availableJobAdd/changeEffectiveData'
export const CHG_MEMO = 'availableJobAdd/changememo'
export const RESET_ADD_DATA = 'availableJobAdd/reset'
export const UPD_ADD_ALERT = 'availableJobAdd/updateAlert'
export const HIDE_ADD_ALERT = 'availableJobAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'availableJobAdd/updateMemoCharCount'
export const INSERT_LOADING = 'availableJobAdd/isLoading'
export const SET_ADD_DATA = 'availableJobAdd/setAddData'
export const CHANGE_UPDATE_VALUES = 'availableJobAdd/changeUpdateValues'
export const FETCH_JOB_VALUES = 'availableJobAdd/fetchJobValues'

// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'availableJobDetail/changeTitle'
export const RESET_DETAIL_DATA = 'availableJobDetail/reset'
export const CHG_DETAIL_DATA = 'availableJobDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'availableJobDetail/changeMode'
export const HAS_DETAIL_LOADED = 'availableJobDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'availableJobDetail/setDetailData'
export const UPD_AMOUNT = 'availableJobDetail/changeAmount'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'availableJobDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'availableJobDetail/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'availableJobDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'availableJobDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'availableJobDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'availableJobDetail/setAlertModal'
export const HIDE_DETAIL_ALERT = 'availableJobDetail/hideAlert'


